var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMenuOverviewInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Eraklient",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "UI-Framework",
    transform: "translate(-240.000000, -315.000000)",
    fill: "#212121"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(240.000000, 311.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-Menu_Overview_Inactive",
    transform: "translate(0.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7072704,7.3095405 C16.0952404,7.6965165 16.0952404,8.3254775 15.7092704,8.7134535 C15.3222904,9.1004295 14.6943304,9.1004295 14.3073504,8.7134535 L13.9783804,8.3844735 L13.9783804,15.0000595 C13.9783804,15.5520255 13.5314004,15.9999975 12.9794404,15.9999975 L9.98262537,15.9999975 C9.43066037,15.9999975 8.98368837,15.5520255 8.98368837,15.0000595 L8.98368837,11.0023095 L6.98581337,11.0023095 L6.98581337,15.0000595 C6.98581337,15.5520255 6.53884137,15.9999975 5.98687637,15.9999975 L2.99006337,15.9999975 C2.43809737,15.9999975 1.99112537,15.5520255 1.99112537,15.0000595 L1.99112537,8.4134715 L1.69214437,8.7134525 C1.30516837,9.1004285 0.677207772,9.1004285 0.290231872,8.7134525 C-0.0967439575,8.3264775 -0.0967439575,7.6975165 0.290231872,7.3095405 L2.25410937,5.3416675 C2.27710737,5.3146675 2.30010637,5.2926675 2.32510437,5.2696675 L7.29779437,0.2909775 C7.68476937,-0.0969925 8.31273137,-0.0969925 8.69870637,0.2909775 L15.7072704,7.3095405 Z M11.9795004,14.0011225 L11.9795004,6.3825975 L7.99875037,2.3958475 L3.98900037,6.4125975 L3.98900037,14.0011225 L4.98693837,14.0011225 L4.98693837,10.0033725 C4.98693837,9.4504065 5.43391037,9.0034345 5.98587637,9.0034345 L9.98162737,9.0034345 C10.5335904,9.0034345 10.9805604,9.4504065 10.9805604,10.0033725 L10.9805604,14.0011225 L11.9795004,14.0011225 Z",
    id: "Combined-Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuOverviewInactive);
export default __webpack_public_path__ + "static/media/Icon-Menu_Overview_Inactive.97d55284c5ed60c05b1aec3c57ec5814.svg";
export { ForwardRef as ReactComponent };